import styled from "styled-components";

export const DeleteModalWrapper = styled.div`
  text-align: center;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 22px;
    line-height: 26px;
  }
  .image-wrap {
    max-width: 150px;
    margin: 0 auto 20px;
    border-radius: 25px;
    padding: 10px;
    background-color: ${({ theme }) => theme?.light?.primary};
    h2 {
      margin-bottom: 20px;
    }
  }
`;
export const SuccessModalWrapper = styled.div`
text-align: center;
margin-bottom: 10px;
font-size: 16px;
line-height: 20px;
font-weight: 400;
@media (min-width: 768px) {
  font-size: 22px;
  line-height: 26px;
}
  .image-wrap{
    max-width: 150px;
    margin: 0 auto 10px;
    border-radius: 25px;
    padding: 10px;
    img{
      width: 100%;
      height: auto;
    }
  }
`;